import React from 'react';
import flattenChildren from 'react-keyed-flatten-children';

type ChildType = React.ReactElement & { type: { displayName: string } };

export default function getChild(name: string, children: React.ReactNode): React.ReactNode {
  const flattened: React.ReactNode[] = flattenChildren(children);

  return flattened.find((child: ChildType): boolean => child.type?.displayName === name);
}
